// src/hooks/useAuth.js
import { useState, useEffect } from 'react';

export function useAuth() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     console.log(!!token)
//     setIsAuthenticated(!!token);
//   }, []);

  const token = localStorage.getItem('token');

  return !!token;
}
